import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Grid, Switch, Typography, styled } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getSmsTemplate,
  updateSmsTemplate,
} from "../../slices/SmsTemplate/SmsTemplateSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

const useStyles = makeStyles((theme) => ({
  text: {
    "& .css-672ulr-MuiTypography-root": {
      marginTop: "-6px",
    },
  },
}));

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function EditSmsTemplate(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isClicked, setIsClicked] = useState(false);
  const [sendSms, setSendSms] = useState(true);
  const [subject, SetSubject] = useState(props.location.state.message);
  const [employeeNameCard, setEmployeeNameCard] = useState(false);
  const [visitorNameCard, setVisitorNameCard] = useState(false);
  const [startTimeCard, setStartTimeCard] = useState(false);
  const [endTimeCard, setEndTimeCard] = useState(false);
  const [companyNameCard, setCompanyNameCard] = useState(false);
  const [acceptLinkCard, setAcceptLinkCard] = useState(false);
  const [qrCodeCard, setQrCodeCard] = useState(false);
  const [firstNameCard, setFirstNameCard] = useState(false);
  const [pinCard, setPinCard] = useState(false);
  const [qrCodeOrPin, setQrCodeOrPin] = useState(false);
  const [linkcard, setLinkCard] = useState(false);
  const [timeCard, setTimeCard] = useState(false);
  const [messageCard, setMessageCard] = useState(false);
  const [deliveryCompanyName, setDeliveryCompanyName] = useState(false);
  const [recipient, setRecipient] = useState("");
  const dispatch = useDispatch();
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [category, setCategory] = useState("");
  const history = useHistory();
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = useState({
    id: "",
    message: "",
    status: "",
  });

  const recepientOptions = [
    { label: "Host" },
    { label: "Visitor" },
    { label: "Employee" },
  ];

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (props.location.state.recipient) {
      setRecipient(props.location.state.recipient);
      setCategory(convertString(props.location.state.code));
      setPayload({
        ...payload,
        id: props.location.state.id,
        status: props.location.state.status,
      });
      setSendSms(props.location.state.status);
    } else {
      setRecipient("");
    }
  }, [props.location.state.recipient, props.location.state.code]);

  useEffect(() => {
    loadData();
  }, [recipient]);

  const loadData = () => {
    const value = recipient;
    let payload = {
      pageNumber: 1,
      pageSize: 20,
      recipient: value,
    };
    dispatch(getSmsTemplate(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "CVAE4001") {
          const options = res.data.templateList.map((item) =>
            convertString(item.code)
          );
          setCategoryOptions(options);
        }
      });
  };

  const convertString = (inputString) => {
    // Split the input string by underscores
    const parts = inputString.split("_");

    // Convert each part to lowercase and capitalize the first letter
    const convertedParts = parts.map((part) => {
      // Convert the part to lowercase
      const lowercasePart = part.toLowerCase();

      // Capitalize the first letter of the part
      if (lowercasePart.length > 0) {
        return lowercasePart.charAt(0).toUpperCase() + lowercasePart.slice(1);
      }

      return lowercasePart;
    });

    // Join the converted parts with spaces
    const result = convertedParts.join(" ");

    return result;
  };

  const handleEmployeeNameClick = (event) => {
    setEmployeeNameCard(!employeeNameCard);
    const value = "${employeeFirstName}";
    if (!employeeNameCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleVisitorNameCard = (event) => {
    setVisitorNameCard(!visitorNameCard);
    const value = "${visitorFirstName}";
    if (!visitorNameCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleStartTimeClick = (event) => {
    setStartTimeCard(!startTimeCard);
    const value = "${startTime}";
    if (!startTimeCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleEndTimeClick = (event) => {
    setEndTimeCard(!endTimeCard);
    const value = "${endTime}";
    if (!endTimeCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleCompanyNameClick = (event) => {
    setCompanyNameCard(!companyNameCard);
    const value = "${companyName}";
    if (!companyNameCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleAcceptLinkClick = (event) => {
    setAcceptLinkCard(!acceptLinkCard);
    const value = "${acceptLink}";
    if (!acceptLinkCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleQrcodeClick = (event) => {
    setFirstNameCard(!firstNameCard);
    const value = "${FirstName}";
    if (!firstNameCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handlePinClick = (event) => {
    setPinCard(!pinCard);
    const value = "${PIN}";
    if (!pinCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleQrOrPinClick = (event) => {
    setQrCodeOrPin(!qrCodeOrPin);
    const value = "${QR-Code/Pin Link}";
    if (!qrCodeOrPin) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleLinkClick = (event) => {
    setLinkCard(!linkcard);
    const value = "${link}";
    if (!linkcard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleTimeClick = (event) => {
    setTimeCard(!timeCard);
    const value = "${Time}";
    if (!timeCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleMessageClick = (event) => {
    setMessageCard(!messageCard);
    const value = "${message}";
    if (!messageCard) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleDeliveryCompanyNameClick = (event) => {
    setDeliveryCompanyName(!deliveryCompanyName);
    const value = "${deliveryCompanyName}";
    if (!deliveryCompanyName) {
      const input = document.getElementById("myTextField");
      const { selectionStart, selectionEnd } = input;
      const newText =
        subject.substring(0, selectionStart) +
        " " +
        value +
        " " +
        subject.substring(selectionEnd);
      SetSubject(newText);
      const newCursorPosition = selectionStart + value.length;
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      const newText = subject.replace(value, "");
      SetSubject(newText);
    }
  };

  const handleChange = (event) => {
    setSendSms(!sendSms);
    setPayload({
      ...payload,
      status: event.target.checked,
    });
  };

  const cardBackgroundColor = isClicked ? "#2281AB" : "white";
  const cardTextColour = isClicked ? "#FFFFFF" : "#242424";

  const handleSubjectChange = (event) => {
    SetSubject(event.target.value);
  };

  useEffect(() => {
    if (!subject.includes("${employeeFirstName}")) {
      setEmployeeNameCard(false);
    }
    if (subject.includes("${employeeFirstName}")) {
      setEmployeeNameCard(true);
    }
    if (!subject.includes("${visitorFirstName}")) {
      setVisitorNameCard(false);
    }
    if (subject.includes("${visitorFirstName}")) {
      setVisitorNameCard(true);
    }
    if (!subject.includes("${startTime}")) {
      setStartTimeCard(false);
    }
    if (subject.includes("${startTime}")) {
      setStartTimeCard(true);
    }
    if (!subject.includes("${endTime}")) {
      setEndTimeCard(false);
    }
    if (subject.includes("${endTime}")) {
      setEndTimeCard(true);
    }
    if (!subject.includes("${companyName}")) {
      setCompanyNameCard(false);
    }
    if (subject.includes("${companyName}")) {
      setCompanyNameCard(true);
    }
    if (!subject.includes("${acceptLink}")) {
      setAcceptLinkCard(false);
    }
    if (subject.includes("${acceptLink}")) {
      setAcceptLinkCard(true);
    }
    if (!subject.includes("${FirstName}")) {
      setFirstNameCard(false);
    }
    if (subject.includes("${FirstName}")) {
      setFirstNameCard(true);
    }
    if (!subject.includes("${PIN}")) {
      setPinCard(false);
    }
    if (subject.includes("${PIN}")) {
      setPinCard(true);
    }
    if (!subject.includes("${QR-Code/Pin Link}")) {
      setQrCodeOrPin(false);
    }
    if (subject.includes("${QR-Code/Pin Link}")) {
      setQrCodeOrPin(true);
    }
    if (!subject.includes("${link}")) {
      setLinkCard(false);
    }
    if (subject.includes("${link}")) {
      setLinkCard(true);
    }
    if (!subject.includes("${Time}")) {
      setTimeCard(false);
    }
    if (subject.includes("${Time}")) {
      setTimeCard(true);
    }
    if (!subject.includes("${message}")) {
      setMessageCard(false);
    }
    if (subject.includes("${message}")) {
      setMessageCard(true);
    }
    if (subject.includes("${deliveryCompanyName}")) {
      setDeliveryCompanyName(true);
    }
    if (!subject.includes("${deliveryCompanyName}")) {
      setDeliveryCompanyName(false);
    }
  }, [subject]);

  const handleSubmit = () => {
    let dto = {
      id: payload.id,
      recipient: recipient,
      message: subject,
      status: payload.status,
    };
    dispatch(updateSmsTemplate(dto))
      .unwrap()
      .then((res) => {
        if (res.code === "CVAE4002") {
          Toast(res.message, "success");
          history.goBack();
        }
      });
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleNottoChange = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar title={t("COMMON077")} back_button={true} />

      <div style={{ height: "calc(100vh - 130px)" }}>
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            height: "93%",
            mt: 2,
            p: 2.5,
            backgroundColor: darkMode ? "#0E2A41" : "",
            overflow: "auto",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item lg={6} sm={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disablePortal
                id="recipient-autocomplete"
                options={recepientOptions}
                value={recipient}
               onChange={(event, value) => {
                  if (!CommonUtil.isEmpty(value)) setRecipient(value.label);
                  else setRecipient("");
                }}
                sx={{ width: "100%" }}
                renderInput={(params) => (
                  <CustomTextfield {...params} required label="Select Recipient" />
                )}
              />
            </Grid>

            <Grid item lg={6} sm={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disablePortal
                id="category-autocomplete"
                options={categoryOptions}
                value={category}
               onChange={(event, newValue) => {
                  if (!CommonUtil.isEmpty(newValue)) setCategory(newValue);
                  else setCategory("");
                }}
                sx={{ width: "100%" }}
                renderInput={(params) => (
                  <CustomTextfield {...params} label="Category" />
                )}
              />
            </Grid>

            <Grid item lg={12} sm={6} xs={6} md={6}>
              <CustomTextfield
                id="subject-textfield"
                label="Subject"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={subject.trim()}
                spellCheck={false}
                InputProps={{ disableUnderline: true }}
                handleChange={handleSubjectChange}
                onCopy={handleNottoChange}
                onPaste={handleNottoChange}
                onCut={handleNottoChange}
              />
            </Grid>
          </Grid>
          <Grid container sx={{ paddingTop: "15px" }} spacing={2}>
            <Grid item>
              <Card
                sx={{
                  backgroundColor: employeeNameCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleEmployeeNameClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: employeeNameCard ? "#FFFFFF" : "#242424",
                    }}
                    className={classes.text}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${employee FirstName}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                sx={{
                  backgroundColor: visitorNameCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleVisitorNameCard}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: visitorNameCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${visitor FirstName}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: startTimeCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleStartTimeClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: startTimeCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${startTime}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: endTimeCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleEndTimeClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: endTimeCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${endTime}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: companyNameCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleCompanyNameClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: companyNameCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${companyName}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: acceptLinkCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleAcceptLinkClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: acceptLinkCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${acceptLink}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: firstNameCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleQrcodeClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: firstNameCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${FirstName}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                sx={{
                  backgroundColor: qrCodeOrPin ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleQrOrPinClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: qrCodeOrPin ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${QR-Code/Pin Link}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: linkcard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleLinkClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: linkcard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${Link}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: timeCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleTimeClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: timeCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${Time}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: messageCard ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleMessageClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: messageCard ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${message}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card
                sx={{
                  backgroundColor: deliveryCompanyName ? "#2281AB" : "white",
                  borderRadius: "20px",
                  border: "1px solid #707070",
                  height: "40px",
                }}
                onClick={handleDeliveryCompanyNameClick}
              >
                <CardContent sx={{ marginTop: "-6px" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: deliveryCompanyName ? "#FFFFFF" : "#242424",
                    }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {"${deliveryCompanyName}"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container sx={{ color: darkMode ? "#ffff" : "", paddingTop: "15px" }} spacing={1}>
            <Grid item >
              <Typography sx={{ fontWeight: "bold" }}>Note :</Typography>
            </Grid>
            <Grid item >
              <Typography>Please use this keywords for SMS Template</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ paddingTop: "7px", marginLeft: "-18px" }} spacing={1} >
            <Grid item>
              <Android12Switch
                checked={sendSms}
                onChange={handleChange}
                name=""
                mode={darkMode}
              />
            </Grid>
            <Grid item sx={{ color: darkMode ? "#fff" : "", mt: "7px" }}>
              <Typography>SMS Template Notification</Typography>
            </Grid>
          </Grid>
          <Grid container style={{ display: "flex", justifyContent: "flex-end" }} spacing={1} >
            <Grid item>
              <CancelButtons
                variant="contained"
                color="secondary"
                onClick={handleCancel}
              >
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("INVITATION003")}
                </Typography>
              </CancelButtons>
            </Grid>
            <Grid item >
              <SubmitButtons variant="contained" onClick={handleSubmit}>
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("COMMON035")}
                </Typography>
              </SubmitButtons>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </>
  );
}

export default EditSmsTemplate;
